import { Flex, Text } from "@gravity-ui/uikit";
import Skeleton from "react-loading-skeleton";

import css from "./ProductPriceDetailsSkeleton.module.scss";
export const ProductPriceDetailsSkeleton = ({
  count = 8,
}: {
  count?: number;
}) => {
  return (
    <Flex direction="column" gap={2}>
      <Flex direction="column" gap={1}>
        <Text variant="subheader-2" color="secondary">
          <Skeleton height={20} width={40} className={css.skeletonCard} />
        </Text>
        <Flex gap={2} wrap>
          {Array.from({ length: count }).map((_, index) => (
            <div key={index}>
              <Skeleton height={28} width={52} className={css.skeletonCard} />
            </div>
          ))}
        </Flex>
      </Flex>
    </Flex>
  );
};
